import React from 'react';
import Grid from '../layout/grid';

export default props => {

	const onChange = data => {

		const valor = data.target.value || null;

		if (props.onChange) {
			props.onChange(valor);
		} else {
			props.input.onChange(valor);
		}
	};

	const value = props.onChange
		? (props.value || '')
		: (props.input.value || '');

	return (
		<Grid cols={props.cols} style={{ minWidth: 165, maxWidth: 165 }}>
			<div className='form-group' style={{ marginBottom: props.marginBottom }}>
				{props.label &&
					<label htmlFor={props.name}>
						{props.label}
					</label>
				}

				<input
					{...props.input}
					className='form-control'
					maskChar=' '
					style={{ fontSize: props.fontSize }}
					placeholder={props.placeholder}
					readOnly={props.readOnly}
					type='date'
					min={props.min}
					max={props.max}
					disabled={props.disabled}
					value={value.split('/').join('-').split('T')[0]}
					onChange={onChange}
				/>
			</div>
		</Grid>
	);
};